
export default {
  name: 'IconClose',
}
